import DashboardUserInfo from './DashboardUserInfo';

export default DashboardUserInfo;